import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import _ from 'underscore';

import { Pricing } from 'services/action';
import { Form, Select } from 'ui/components';
import { SkeletonsForm, Skeletons } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  service: null,
  origin: null,
  options: null,
  destination: null,
  service_type: null,
  pricing_schema: null,
  nlv: '',
  min_weight: '',
  originType: 'Kelurahan',
  destinationType: 'Kelurahan-des',
  price: [
    {
      weight_less: '',
      nlv: '',
    },
  ],
};

const initialOptions = [
  { value: 'weight_point_based', label: 'Berbasis Berat per Titik' },
  { value: 'weight_based', label: 'Berbasis Berat per Kg' },
  { value: 'trip_based', label: 'Berbasis Perjalanan' },
  { value: 'colly_based', label: 'Berbasis Koli' },
  { value: 'dedicated_monthly', label: 'Berbasis Dedicated Perbulan' },
  { value: 'dedicated_daily', label: 'Berbasis Dedicated Perhari' },
];

export const FormPricing = ({ data, customer_id, onClose, onSuccess }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [
    {
      service,
      origin,
      destination,
      service_type,
      nlv,
      originType,
      destinationType,
      price,
      pricing_schema,
      min_weight,
      options,
      isLoading,
    },
    setState,
  ] = React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleItemsChange = async (i, e) => {
    let newItems = [...price];
    newItems[i][e.target.name] = e.target.valueNumber
      ? e.target.valueNumber
      : e.target.value;

    setState((prevState) => ({
      ...prevState,
      price: newItems,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      price: [
        ...price,
        {
          weight_less: '',
          nlv: '',
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...price];
    newItems.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      price: newItems,
    }));
  };

  const $handleSubmit = async (c) => {
    const payload = {
      service: service?.id,
      origin,
      destination,
      service_type_id: service_type?.id,
      pricing_schema: pricing_schema?.value,
      min_weight: parseFloat(min_weight || 0),
    };

    if (pricing_schema?.value === 'weight_point_based') {
      let pricing = [];
      if (price) {
        price.forEach((item) => {
          pricing.push({
            weight_less: parseFloat(item?.weight_less || 0),
            nlv: parseFloat(item?.nlv || 0),
            clv: null,
          });
        });
      }
      payload.weight_ranges = pricing;
    } else {
      payload.nlv = parseFloat(nlv);
    }

    let submit = null;

    if (customer_id) {
      payload.customer_id = customer_id;
    }

    if (data) {
      submit = await Dispatch(Pricing.$update(data?.id, payload));
    } else {
      submit = await Dispatch(Pricing.$create(payload));
    }

    if (submit?.message === 'success') {
      clearState();
      onSuccess();
    }
  };

  React.useEffect(() => {
    const opt = _.filter(initialOptions, function (item) {
      if (service?.id === '61cc19d9f42b986ab50c659b') {
        return (
          item?.value === 'dedicated_monthly' ||
          item?.value === 'dedicated_daily' ||
          item?.value === 'trip_based'
        );
      } else {
        return (
          item?.value !== 'dedicated_monthly' &&
          item?.value !== 'dedicated_daily'
        );
      }
    });

    setState((prevState) => ({ ...prevState, options: opt }));
  }, [service]);

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    let pricing = [];
    if (data?.weight_ranges) {
      data?.weight_ranges?.forEach((item) => {
        pricing.push({
          weight_less: item?.weight_less,
          nlv: item?.nlv,
        });
      });
    }

    let ot = '';
    if (data?.origin?.village_id) {
      ot = 'Kelurahan';
    }else if (data?.origin?.district_id) {
      ot = 'Kecamatan';
    } else if (data?.origin?.regency_id) {
      ot = 'Kota/Kabupaten';
    } else {
      ot = 'Provinsi';
    }

    let dt = '';
    if (data?.destination?.village_id) {
      dt = 'Kelurahan-des';
    } else if (data?.destination?.district_id) {
      dt = 'Kecamatan-des';
    } else if (data?.destination?.regency_id) {
      dt = 'Kota/Kabupaten-des';
    } else {
      dt = 'Provinsi-des';
    }

    const ps =
      data?.pricing_schema === 'weight_point_based'
        ? initialOptions[0]
        : data?.pricing_schema === 'weight_based'
        ? initialOptions[1]
        : data?.pricing_schema === 'trip_based'
        ? initialOptions[2]
        : data?.pricing_schema === 'colly_based'
        ? initialOptions[3]
        : data.pricing_schema === 'dedicated_monthly'
        ? initialOptions[4]
        : data.pricing_schema === 'dedicated_daily'
        ? initialOptions[5]
        : null;

    setState((prevState) => ({
      ...prevState,
      service: data?.service_type?.service,
      service_type: data?.service_type,
      originType: ot,
      destinationType: dt,
      price: pricing,
      origin: data?.origin,
      destination: data?.destination,
      nlv: data?.nlv,
      pricing_schema: ps,
      min_weight: data?.min_weight,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <Modal.Body>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}

          <div className="col-md-6">
            <Skeletons height={200} />
          </div>
          <div className="col-md-6">
            <Skeletons height={200} />
          </div>
        </div>
      </Modal.Body>
    );
  }


  return (
    <>
      <Modal.Body>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Jenis Layanan"
                isSearch={false}
                placeholder=""
                url="/tms/service/use"
                value={service}
                initialValue={service?.id || data?.service_type?.service?.id}
                params={{ order_by: 'id' }}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d.name,
                  };
                }}
                onSelected={(v) => {
                  setState((prevState) => ({
                    ...initialState,
                    isLoading: false,
                    service: v,
                    service_type: null,
                  }));
                }}
                errors={StateForm?.errors?.service_type_id}
              />
            </div>

            <div className="mb-3">
              <Select.Remote
                required
                isSearch={false}
                label="Pilih Tipe Layanan"
                placeholder=""
                url="/tms/service/type"
                value={service_type}
                params={{
                  service_id: service?.id,
                }}
                initialValue={service_type?.id}
                row={(d) => {
                  return {
                    value: d.id,
                    label: d.name,
                  };
                }}
                onSelected={(v) => {
                  setState((prevState) => ({
                    ...prevState,
                    service_type: v,
                  }));
                }}
                errors={StateForm?.errors?.service_type_id}
                disabled={!service}
                keys={service?.id}
              />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mb-3">
              <label className={'form-label required'}>Pilih Skema Harga</label>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.pricing_schema ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={pricing_schema}
                options={options}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    pricing_schema: e,
                  }))
                }
                error={StateForm?.errors?.type}
                isDisabled={!service}
              />

              {StateForm?.errors?.pricing_schema ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.pricing_schema}
                </div>
              ) : null}
            </div>

            {pricing_schema && pricing_schema?.value === 'weight_based' && (
              <Form.Input
                autoComplete="off"
                label="Berat Minimal (Kg) "
                name="min_weight"
                type="number"
                value={min_weight}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    min_weight: e.target.valueNumber,
                  }))
                }
                error={StateForm?.errors?.min_weight}
              />
            )}

            {pricing_schema &&
            pricing_schema?.value !== 'weight_point_based' ? (
              <Form.Input
                required
                value={nlv}
                onChange={(e) => {
                  setState((prevState) => ({
                    ...prevState,
                    nlv: e.target.valueNumber,
                  }));
                }}
                type="number"
                label="Harga Jual"
                error={StateForm?.errors?.nlv}
              />
            ) : null}
          </div>

          {pricing_schema &&
          pricing_schema?.value !== 'dedicated_monthly' &&
          pricing_schema?.value !== 'dedicated_daily' ? (
            <>
              <div className="col-6 mt-3">
                <div className="border p-2 rounded mb-3">
                  <div className="my-2">
                    <label className="form-label">Pilih Tipe Asal/Origin</label>
                    <div className="inline-radio">
                      <Form.Radio
                        defaultChecked={originType === 'Kelurahan'}
                        type="radio"
                        inline
                        name="origin"
                        label="Kelurahan"
                        id="Kelurahan"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            originType: e.target.id,
                            origin: null,
                          }));
                        }}
                      />
                      <Form.Radio
                        defaultChecked={originType === 'Kecamatan'}
                        type="radio"
                        inline
                        name="origin"
                        label="Kecamatan"
                        id="Kecamatan"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            originType: e.target.id,
                            origin: null,
                          }));
                        }}
                      />
                      <Form.Radio
                        defaultChecked={originType === 'Kota/Kabupaten'}
                        type="radio"
                        inline
                        name="origin"
                        label="Kota/Kabupaten"
                        id="Kota/Kabupaten"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            originType: e.target.id,
                            origin: null,
                          }));
                        }}
                      />
                      <Form.Radio
                        defaultChecked={originType === 'Provinsi'}
                        type="radio"
                        inline
                        name="origin"
                        label="Provinsi"
                        id="Provinsi"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            originType: e.target.id,
                            origin: null,
                          }));
                        }}
                      />
                    </div>
                  </div>

                  {originType ? (
                    <div className="mb-3">
                      <Select.Remote
                        required
                        label={`Pilih ${originType} Asal/Origin`}
                        placeholder=""
                        url={
                          originType === 'Kelurahan'
                            ? '/region'
                            : originType === 'Kecamatan'
                            ? '/region/district'
                            : originType === 'Kota/Kabupaten'
                            ? '/region/regency'
                            : '/region/province'
                        }
                        value={origin}
                        initialValue={
                          origin?.village_id ||
                          origin?.regency_id ||
                          origin?.province_id
                        }
                        params={{
                          search:
                            originType === 'Kelurahan'
                              ? origin?.postal_code
                              : originType !== 'Kelurahan' ? origin?.province_name : '',
                        }}
                        row={(d) => {
                          return {
                            value: d.village_id,
                            label:
                              originType === 'Kelurahan'
                                ? `${d.village_name}, ${d?.district_name}, ${d.regency_name}, ${d?.province_name} ${d?.postal_code}`
                                : originType === 'Kecamatan'
                                ? `${d.district_name}, ${d?.regency_name}, ${d?.province_name}`
                                : originType === 'Kota/Kabupaten'
                                ? `${d.regency_name}, ${d?.province_name}`
                                : `${d?.province_name}`,
                          };
                        }}
                        onSelected={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            origin: e,
                          }));
                        }}
                        hint={
                          originType === 'Kelurahan'
                            ? 'cari nama kelurahan/kode pos'
                            : originType === 'Kecamatan'
                            ? 'cari nama kecamatan'
                            : originType === 'Kota/Kabupaten'
                            ? 'cari nama kota/kabupaten'
                            : 'cari nama provinsi'
                        }
                        errors={
                          StateForm?.errors?.origin || StateForm?.errors?.id
                        }
                        key={originType}
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="col-6 mt-3">
                <div className="border p-2 rounded mb-3">
                  <div className="my-2">
                    <label className="form-label">
                      Pilih Tipe Tujuan/Destination
                    </label>
                    <div className="inline-radio">
                      <Form.Radio
                        defaultChecked={destinationType === 'Kelurahan-des'}
                        type="radio"
                        inline
                        name="destinasi"
                        label="Kelurahan"
                        id="Kelurahan-des"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            destinationType: e.target.id,
                            destination: null,
                          }));
                        }}
                      />
                      <Form.Radio
                        defaultChecked={destinationType === 'Kecamatan-des'}
                        type="radio"
                        inline
                        name="destinasi"
                        label="Kecamatan"
                        id="Kecamatan-des"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            destinationType: e.target.id,
                            destination: null,
                          }));
                        }}
                      />
                      <Form.Radio
                        defaultChecked={
                          destinationType === 'Kota/Kabupaten-des'
                        }
                        type="radio"
                        inline
                        name="destinasi"
                        label="Kota/Kabupaten"
                        id="Kota/Kabupaten-des"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            destinationType: e.target.id,
                            destination: null,
                          }));
                        }}
                      />
                      <Form.Radio
                        defaultChecked={destinationType === 'Provinsi-des'}
                        type="radio"
                        inline
                        name="destinasi"
                        label="Provinsi"
                        id="Provinsi-des"
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            destinationType: e.target.id,
                            destination: null,
                          }));
                        }}
                      />
                    </div>
                  </div>

                  {destinationType ? (
                    <div className="mb-3">
                      <Select.Remote
                        required
                        label={`Pilih ${destinationType?.replace(
                          '-des',
                          ''
                        )} Tujuan/Destination`}
                        placeholder=""
                        url={
                          destinationType === 'Kelurahan-des'
                            ? '/region'
                            : destinationType === 'Kecamatan-des'
                            ? '/region/district'
                            : destinationType === 'Kota/Kabupaten-des'
                            ? '/region/regency'
                            : '/region/province'
                        }
                        initialValue={
                          destination?.village_id ||
                          destination?.district_id ||
                          destination?.regency_id ||
                          destination?.province_id
                        }
                        params={{
                          search:
                            destinationType === 'Kelurahan-des'
                              ? destination?.postal_code
                              : destinationType !== 'Kelurahan-des' ? destination?.province_name : '',
                        }}
                        row={(d) => {
                          return {
                            value: d.village_id,
                            label:
                              destinationType === 'Kelurahan-des'
                                ? `${d.village_name}, ${d?.district_name}, ${d.regency_name}, ${d?.province_name} ${d?.postal_code}`
                                : destinationType === 'Kecamatan-des'
                                ? `${d.district_name}, ${d.regency_name}, ${d?.province_name}`
                                : destinationType === 'Kota/Kabupaten-des'
                                ? `${d.regency_name}, ${d?.province_name}`
                                : `${d?.province_name}`,
                          };
                        }}
                        onSelected={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            destination: e,
                          }));
                        }}
                        hint={
                          destinationType === 'Kelurahan-des'
                            ? 'cari nama kecamatan/kode pos'
                            : destinationType === 'Kecamatan-des'
                            ? 'cari nama kecamatan'
                            : destinationType === 'Kota/Kabupaten-des'
                            ? 'cari nama kota/kabupaten'
                            : 'cari nama provinsi'
                        }
                        errors={
                          StateForm?.errors?.destination ||
                          StateForm?.errors?.id
                        }
                        key={destinationType}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ) : null}

          {pricing_schema && pricing_schema?.value === 'weight_point_based' ? (
            <div className="mb-3">
              <div className="border rounded">
                <div className="mt-2 mb-2 mx-3 border-bottom">
                  <label className={'form-label required'}>
                    Daftar Kisaran Harga
                  </label>
                </div>
                {price?.map((e, i) => (
                  <div
                    className={cn(
                      'row align-items-center border-bottom py-2 m-0'
                    )}
                    key={i}
                  >
                    <div className="col-10">
                      <div className="row m-0">
                        <>
                          {/* weight_point_based */}
                          <div className="col-md-6">
                            <Form.Input
                              autoComplete="off"
                              label="Berat Minimal (Kg) "
                              name="weight_less"
                              type="number"
                              value={e?.weight_less}
                              onChange={(e) => $handleItemsChange(i, e)}
                              error={
                                StateForm?.errors?.weight_ranges ||
                                StateForm?.errors[
                                  `weight_ranges.${i}.weight_less`
                                ]
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <Form.Input
                              autoComplete="off"
                              label="Harga Jual"
                              name="nlv"
                              type="number"
                              value={e?.nlv}
                              onChange={(e) => $handleItemsChange(i, e)}
                              error={
                                StateForm?.errors?.weight_ranges ||
                                StateForm?.errors[`weight_ranges.${i}.nlv`]
                              }
                            />
                          </div>
                        </>
                      </div>
                    </div>
                    <div className="col-2">
                      {i ? (
                        <button
                          type="button"
                          className="btn btn-danger rounded"
                          style={{ minHeight: 25, minWidth: '100%' }}
                          onClick={() => $removeField(i)}
                        >
                          <Fi.FiX />
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary rounded"
                          style={{ minHeight: 25, minWidth: '100%' }}
                          onClick={() => $addMoreFields()}
                        >
                          <Fi.FiPlus />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button
              type="button"
              className="btn btn-light w-100"
              onClick={() => onClose()}
            >
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'btn btn-primary w-100'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
